import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IUserOrganization, UserOrganizationAffiliationType } from '../interfaces/userOrganization';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

export const fetchUserOrganizationsRequest = () =>
  ({
    type: 'FETCH_USER_ORGANIZATIONS_REQUEST'
  } as const);

export const fetchUserOrganizationsSuccess = (payload: IUserOrganization[]) =>
  ({
    type: 'FETCH_USER_ORGANIZATIONS_SUCCESS',
    payload
  } as const);

export const setAllUserOrganizations = (payload: IUserOrganization[]) =>
  ({
    type: 'SET_ALL_USER_ORGANIZATIONS',
    payload
  } as const);

export const fetchUserOrganizationsFailure = (error: AxiosError | Error) => {
  sendError(error);
  return {
    type: 'FETCH_USER_ORGANIZATIONS_FAILURE',
    error
  } as const;
};

export const shouldFetchUserOrganizations = (state: CommonRootState) => {
  const {
    userOrganizations: { isFetching, error, userOrganizations }
  } = state;

  return !isFetching && !error && !userOrganizations;
};

export const fetchUserOrganizations = (
  filter = (userOrganization: IUserOrganization) =>
    userOrganization.affiliationType === UserOrganizationAffiliationType.Legacy,
  userId?: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchUserOrganizationsRequest());

    const response = await axios.get<IUserOrganization[]>('/api/v3.3/userOrganizations', {
      params: {
        userId,
        shouldIncludeSubsidiaries: true
      }
    });

    dispatch(setAllUserOrganizations(response.data));

    const userOrganizations = response.data.filter(filter);

    dispatch(fetchUserOrganizationsSuccess(userOrganizations));
  } catch (error) {
    dispatch(fetchUserOrganizationsFailure(error));
  }
};

export const fetchUserOrganizationsIfNeeded = (
  filter?: (userOrganization: IUserOrganization) => boolean,
  userId?: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchUserOrganizations(getState())) {
    dispatch(fetchUserOrganizations(filter, userId));
  }
};

export type Actions =
  | ReturnType<typeof fetchUserOrganizationsRequest>
  | ReturnType<typeof fetchUserOrganizationsSuccess>
  | ReturnType<typeof fetchUserOrganizationsFailure>
  | ReturnType<typeof setAllUserOrganizations>;
